import { inject, Pipe, PipeTransform } from '@angular/core';
import { FormatService } from '../services/format.service';


@Pipe({
  name: 'formatCoinCurrency',
  standalone: true,
})
export class FormatCoinCurrencyPipe implements PipeTransform {
  private formatService = inject(FormatService);

  transform(value: number | null | undefined, precision = 0, currency?: string): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '—';
    }

    return this.formatService.formatCoinCurrency(value, precision, currency);
  }
}
